const useDeleteZeros = (value: string): string => {
    return value.substring(0,value.length-3)
}
export default useDeleteZeros;